"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAllScopes = exports.fetchAllRows = exports.fetchRows = void 0;
const MAX_PAGINATION_FETCHES = 20;
// work around the limit bug in nodeos due to max timeout
// https://github.com/EOSIO/eos/issues/3965
exports.fetchRows = (rpc) => async (options) => {
    const mergedOptions = Object.assign({ json: true, lower_bound: undefined, upper_bound: undefined, limit: 9999 }, options);
    let lowerBound = mergedOptions.lower_bound;
    const result = await rpc.get_table_rows(Object.assign(Object.assign({}, mergedOptions), { lower_bound: lowerBound }));
    return result.rows;
};
exports.fetchAllRows = (rpc) => async (options, indexName = `id`) => {
    const mergedOptions = Object.assign({ json: true, lower_bound: 0, upper_bound: undefined, limit: 9999 }, options);
    let rows = [];
    let lowerBound = mergedOptions.lower_bound;
    /* eslint-disable no-await-in-loop */
    for (let i = 0; i < MAX_PAGINATION_FETCHES; i += 1) {
        const result = await rpc.get_table_rows(Object.assign(Object.assign({}, mergedOptions), { lower_bound: lowerBound }));
        rows = rows.concat(result.rows);
        if (!result.more || result.rows.length === 0)
            break;
        // EOS 2.0 api
        if (typeof result.next_key !== `undefined`) {
            lowerBound = result.next_key;
        }
        else {
            lowerBound = Number.parseInt(`${result.rows[result.rows.length - 1][indexName]}`, 10) + 1;
        }
    }
    return rows;
};
exports.fetchAllScopes = (rpc) => async (contract, table) => {
    const mergedOptions = {
        json: true,
        lower_bound: undefined,
        upper_bound: undefined,
        limit: 9999,
        code: contract,
        table,
    };
    const rows = (await rpc.get_table_by_scope(mergedOptions)).rows;
    return rows.map(row => row.scope);
};
